export default __webpack_public_path__ + "static/media/visual_large.772697d1.jpg";